import PropTypes from 'prop-types'
import { useContext, useEffect, useState } from 'react'
import InputText from '../../../common/InputText'
import Button from '../../../common/Button'
import { getRequest, putRequest } from '../../../../services/base'
import { NavContext } from '../../../../context/global_context'
import { ConnectorContext } from '../context/context'
import SelectInput from '../../../common/SelectInput'
import TextArea from '../../../common/TextArea'
import { useParams } from 'react-router-dom'
import FileField from '../../../common/FileField'
import { XCircle } from '@styled-icons/boxicons-solid'

const CONNECTOR_CATEGORY_NAMES = {
  inline: 'Inline',
  splice: 'Splice',
  fuse: 'Fuse',
  module: 'Module',
  joint: 'Joint',
  high_voltage: 'High Voltage',
  ground: 'Ground',
  not_electrical: 'Not Electrical',
  power_distribution: 'Power Distribution',
  connector: 'Connector',
}

const CONNECTOR_CATEGORY_OPTIONS = [
  { value: 'inline', label: CONNECTOR_CATEGORY_NAMES.inline },
  { value: 'splice', label: CONNECTOR_CATEGORY_NAMES.splice },
  { value: 'fuse', label: CONNECTOR_CATEGORY_NAMES.fuse },
  { value: 'module', label: CONNECTOR_CATEGORY_NAMES.module },
  { value: 'joint', label: CONNECTOR_CATEGORY_NAMES.joint },
  { value: 'high_voltage', label: CONNECTOR_CATEGORY_NAMES.high_voltage },
  { value: 'ground', label: CONNECTOR_CATEGORY_NAMES.ground },
  { value: 'not_electrical', label: CONNECTOR_CATEGORY_NAMES.not_electrical },
  {
    value: 'power_distribution',
    label: CONNECTOR_CATEGORY_NAMES.power_distribution,
  },
  { value: 'connector', label: CONNECTOR_CATEGORY_NAMES.connector },
]

const ConnectorForm = (props) => {
  const { vehicle } = useParams()
  const [connectorDetails, setConnectorDetails] = useState({})
  const [value, dispatch] = useContext(NavContext)
  const [connectorState, connectorDispatch] = useContext(ConnectorContext)
  const [colorOptions, setColorOptions] = useState([])
  const [deviceOptions, setDeviceOptions] = useState([])

  useEffect(() => {
    if (connectorState?.selectedConnector?.id) {
      setConnectorDetails(connectorState.selectedConnector)
      getColorOptions('')
    }
  }, [connectorState?.selectedConnector])

  const saveConnectorDetails = async (e) => {
    let formData = new FormData(e.target)

    let res = await putRequest(
      `/api/connector/save_connector/${connectorDetails.id}/`,
      formData
    )
    if (res?.status) {
      dispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: `Connector saved successfully`,
        },
      })

      connectorDispatch({
        type: 'update_change_connector',
        data: connectorDetails,
      })
      props.onSave()
    } else {
      dispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: res?.msg?.[0],
        },
      })
    }
  }

  const getColorOptions = async (search = '') => {
    let res = await getRequest(
      `/api/color/?vehicle=${vehicle}&search=${search}`
    )
    setColorOptions(res.results)
  }

  const getDeviceOptions = async (search = '') => {
    let res = await getRequest(
      `/api/devices/?vehicle=${vehicle}&search=${search}`
    )
    setDeviceOptions(res.results)
  }

  return (
    <div className="">
      <form
        onSubmit={(e) => {
          e.preventDefault()
          saveConnectorDetails(e)
        }}
      >
        <input type="hidden" value={connectorDetails.name} name="name" />
        <input type="hidden" value={connectorDetails.device} name="device" />
        <input type="hidden" value={connectorDetails.hidden} name="component" />
        <div className="flex">
          <div className="w-1/2">
            <InputText
              name="color"
              type="text"
              label="Color"
              value={connectorDetails.color}
              isRequired={false}
              onChange={(value) => {
                setConnectorDetails({ ...connectorDetails, color: value })
              }}
            />
          </div>
          <div className="w-1/2">
            <SelectInput
              options={CONNECTOR_CATEGORY_OPTIONS}
              value={{
                label: CONNECTOR_CATEGORY_NAMES[connectorDetails.category],
                value: connectorDetails.category,
              }}
              name="category"
              label="Category"
              onChange={(value) => {
                setConnectorDetails({
                  ...connectorDetails,
                  category: value.value,
                })
              }}
            />
          </div>
        </div>
        <div className="flex">
          <div className="w-1/2">
            <InputText
              name="cavities"
              type="text"
              label="Cavities"
              value={connectorDetails.cavities}
              onChange={(value) => {
                setConnectorDetails({ ...connectorDetails, cavities: value })
              }}
            />
          </div>
          <div className="w-1/2">
            <InputText
              name="icon"
              type="text"
              label="Icon"
              value={connectorDetails.icon}
              isRequired={false}
              onChange={(value) => {
                setConnectorDetails({ ...connectorDetails, icon: value })
              }}
            />
          </div>
        </div>
        <div className="flex">
          <div className="w-1/2">
            <TextArea
              name="description"
              type="text"
              label="Description"
              value={connectorDetails.description}
              onChange={(value) => {
                setConnectorDetails({ ...connectorDetails, description: value })
              }}
            />
          </div>
          <div className="w-1/2">
            <SelectInput
              name="device_data"
              label="Device"
              options={deviceOptions}
              value={connectorDetails?.device_data}
              onInputChange={(value) => {
                if (value) {
                  getDeviceOptions(value)
                }
              }}
              onChange={(value) => {
                if (value) {
                  setConnectorDetails({
                    ...connectorDetails,
                    device_data: value,
                    device: value?.id,
                  })
                } else {
                  setConnectorDetails({
                    ...connectorDetails,
                    device_data: null,
                    device: null,
                  })
                }
              }}
              onMenuOpen={() => {
                if (deviceOptions?.length < 1) {
                  getDeviceOptions('')
                }
              }}
              optionLabel={'name'}
              optionValue={'id'}
              isRequired={false}
            />
          </div>
        </div>
        <div className="flex">
          <div className="w-1/2">
            <InputText
              name="alias"
              type="text"
              label="Alias"
              value={connectorDetails.alias}
              onChange={(value) => {
                setConnectorDetails({ ...connectorDetails, alias: value })
              }}
              isRequired={false}
              isDefaultValue={false}
            />
          </div>
          <div className="w-1/2">
            <InputText
              name="postfix"
              type="text"
              label="Postfix"
              value={connectorDetails.postfix}
              isRequired={false}
              onChange={(value) => {
                setConnectorDetails({ ...connectorDetails, postfix: value })
              }}
              isDefaultValue={false}
            />
          </div>
        </div>
        <div className="flex">
          <div className="w-1/2">
            <InputText
              name="fpn"
              type="text"
              label="Part Number"
              value={connectorDetails.fpn}
              onChange={(value) => {
                setConnectorDetails({ ...connectorDetails, fpn: value })
              }}
              isRequired={false}
              isDefaultValue={false}
            />
          </div>
          <div className="w-1/2">
            <InputText
              name="svg_group_reference"
              type="text"
              label="SVG Group Reference"
              value={connectorDetails.svg_group_reference}
              isRequired={false}
              onChange={(value) => {
                setConnectorDetails({
                  ...connectorDetails,
                  svg_group_reference: value,
                })
              }}
              isDefaultValue={false}
            />
          </div>
        </div>
        <div className="flex">
          <div className="w-full flex">
            {!connectorDetails?.terminal_side_svg && !connectorDetails.svg && (
              <FileField
                name={'connector_side_svg'}
                key={`connector_side_svg`}
                label="Connector Side SVG"
                isRequired={false}
                onChange={(e) => {
                  setConnectorDetails({
                    ...connectorDetails,
                    connector_side_svg: 'new svg',
                  })
                }}
              />
            )}

            {!connectorDetails?.connector_side_svg && !connectorDetails.svg && (
              <FileField
                name={'terminal_side_svg'}
                key={`terminal_side_svg`}
                label="Terminal Side SVG"
                isRequired={false}
                onChange={(e) => {
                  setConnectorDetails({
                    ...connectorDetails,
                    terminal_side_svg: 'new svg',
                  })
                }}
              />
            )}

            {connectorDetails.svg && (
              <div className="p-2 w-full text-white">
                <div className="text-white">SVG</div>
                <XCircle
                  className={'w-4 text-red-500 mr-3'}
                  onClick={(e) =>
                    setConnectorDetails({
                      ...connectorDetails,
                      svg: null,
                    })
                  }
                />
                {connectorDetails.name}.svg
              </div>
            )}
          </div>
        </div>
        <div className="flex justify-end">
          <div className="w-1/4 mr-2">
            <Button
              type="submit"
              className={`cursor-pointer btn my-4 w-full justify-end`}
              onClick={(e) => {}}
              value={'text'}
              text={'Save Connector'}
            />
          </div>
        </div>
      </form>
    </div>
  )
}

ConnectorForm.propTypes = {
  onSave: PropTypes.func.isRequired,
}

export default ConnectorForm
